import React, {useEffect, useState} from 'react';
import InviteOthers from "../components/InviteOthers";
import {useNavigate} from "react-router-dom";


const WalletPage = () => {
    const navigate = useNavigate();
    const [showPage, setShowPage] = useState(false);

    useEffect(() => {

        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;

        if(token) {
            if(window.localStorage.getItem("needRegistration") === '1'){
                navigate('/register');
            }
            setShowPage(true)
        }
        else {
             localStorage.setItem('redirectAfterLogin', window.location.pathname);
             localStorage.setItem('redirectAfterLogin', window.location.pathname);
            navigate('/unauthorize', { replace: true });
        }

    }, []);
    return (
        <React.Fragment >
            {showPage ?
                <InviteOthers />
                : ''
            }

        </React.Fragment>
    );
};

export default WalletPage;